export default __webpack_public_path__ + "static/media/Program.d055cf51.jpg";